module.exports = __webpack_public_path__ + "img/factory.4ca832e8.png";